var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeparate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Separate"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.9089 5.13807C6.16925 4.87772 6.16925 4.45561 5.9089 4.19526C5.64855 3.93491 5.22644 3.93491 4.9661 4.19526L1.63276 7.5286C1.37241 7.78894 1.37241 8.21106 1.63276 8.4714L4.9661 11.8047C5.22644 12.0651 5.64855 12.0651 5.9089 11.8047C6.16925 11.5444 6.16925 11.1223 5.9089 10.8619L3.04698 8L5.9089 5.13807Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2422 4.19526C10.9819 3.93491 10.5598 3.93491 10.2994 4.19526C10.0391 4.45561 10.0391 4.87772 10.2994 5.13807L13.1614 8L10.2994 10.8619C10.0391 11.1223 10.0391 11.5444 10.2994 11.8047C10.5598 12.0651 10.9819 12.0651 11.2422 11.8047L14.5756 8.4714C14.8359 8.21106 14.8359 7.78894 14.5756 7.5286L11.2422 4.19526Z",
    fill: "#C0C0C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparate);
export default __webpack_public_path__ + "static/media/separate.c6c7ac4d43f42c914e068ff88b804f88.svg";
export { ForwardRef as ReactComponent };